import "leaflet/dist/leaflet.css";
import "./index.css";

import { GeoJSON, MapContainer, TileLayer, ZoomControl } from "react-leaflet";
import { MIROSLAVA_BOUNDARY } from "./miroslava-boundary";

const MIROSLAVA_CENTER: [number, number] = [47.15, 27.517];

const TILE_URL =
  "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png";
const ATTRIBUTION = "&copy; OpenStreetMap contributors & CARTO";

export function App() {
  return (
    <div className="app-root">
      <MapContainer
        center={MIROSLAVA_CENTER as any}
        zoom={12}
        className="map-root"
        scrollWheelZoom
        zoomControl={false}
      >
        <TileLayer attribution={ATTRIBUTION} url={TILE_URL} />
        <ZoomControl position="bottomleft" />
        <GeoJSON
          // OSM administrative boundary polygon for Miroslava
          data={MIROSLAVA_BOUNDARY as any}
          style={() => ({
            color: "#ff4b4b",
            weight: 2,
            fillOpacity: 0.08,
          })}
        />
      </MapContainer>
    </div>
  );
}
